(ns dashboard.views.analysis.synchronization.view
  (:require [dashboard.components.paginated-list.view :as paginated-list]
            [dashboard.entity.analysis.profile :as analysis.profile]
            [dashboard.ui :as ui]
            [dashboard.views.analysis.synchronization.config :as config]
            [dashboard.views.analysis.synchronization.events :as events]
            [dashboard.views.analysis.synchronization.subs :as subs]
            [io.repliance.util.tree :as tree]
            [re-frame.core :as rf]))

(defn make-mapping-rows [new-structured-analyses my-structured-analyses mappings state]
  (let [question-id->structured-analyses (group-by #(select-keys % [:question-id :question-content]) mappings)
        questions (sort-by (fn [[_k [{:keys [question-ordinal]}] :as _entry]]
                             question-ordinal)
                           question-id->structured-analyses)]
    (for [[{:keys [question-id question-content]} analyses] questions]
      [:tr {:key question-id}
       [:td question-content]
       [:td
        (for [{:keys [construct-id]} (sort-by :construct-id analyses)]
          [:div.is-flex {:key construct-id}
           [:div.mr-2 (analysis.profile/format-analysis-id construct-id)]
           [:div (:construct (first (or (get new-structured-analyses construct-id)
                                        (get my-structured-analyses construct-id))))]])]
       [:td
        (case state
          :new [:div.has-text-weight-semibold.has-text-success "New"]
          :removed [:div.has-text-weight-semibold.has-text-danger "Removed"])]])))

(def column-config
  [{:label "ID"
    :id :id
    :sort-key :construct-id
    :render (fn [{:keys [construct-id]}]
              [:div {:style {:min-width "64px"}}
               (analysis.profile/format-analysis-id construct-id)])}
   {:label  "Construct"
    :id :construct
    :sort-key :construct
    :render (fn [{:keys [construct]
                  :tree/keys [depth]}]
              [:div {:style {:padding-left (str (* (dec depth) 24) "px")}}
               (when (> depth 0)
                 [:div.mr-2.branch-icon])
               construct])}])

(defn sync-modal [{{:keys [on-commit]} :ctx :keys [on-close]}]
  (let [committing? @(rf/subscribe [::subs/is-committing])

        new-structured-analyses @(rf/subscribe [::subs/synchronized-structured-analyses-data])
        my-structured-analyses @(rf/subscribe [::subs/my-structured-analyses])

        removed-template-questionnaires @(rf/subscribe [::subs/removed-template-questionnaires])
        master-synchronization-state @(rf/subscribe [::subs/master-synchronization-state])]
    [:div.card
     [:div.card-header.has-background-primary
      [:title.card-header-title "Synchronization from master"]
      [:button.card-header-icon {:on-click on-close}
       [:span.icon [:i.fas.fa-xmark]]]]
     [:div.card-content {:style {:max-height "75vh" :overflow-y "scroll"}}
      [:div.mb-4
       [:h4.title.is-4 "Template changes"]
       [:div.ml-4
        (for [{:keys [questionnaire new-mappings removed-mappings metadata-changes]} (:changed-template-questionnaires master-synchronization-state)
              :let [{:keys [id custom-name filename]} questionnaire]]
          [:div.mb-4 {:key id}
           [:h5.title.is-5 (if-let [custom-name-changes (:custom-name metadata-changes)]
                             (let [{:keys [my master]} custom-name-changes]
                               [:<>
                                [:span my]
                                [:span.mx-2 "->"]
                                [:span master]])
                             (or custom-name filename))]
           [:table.table
            [:thead
             [:tr
              [:th "Question"]
              [:th "Structured Analysis"]
              [:th]]]
            [:tbody
             [:<>
              (make-mapping-rows new-structured-analyses my-structured-analyses new-mappings :new)
              (make-mapping-rows new-structured-analyses my-structured-analyses removed-mappings :removed)]]]])]
       (when (seq removed-template-questionnaires)
         [:<>
          [:h4.title.is-4 "Removed templates"]
          [:div.ml-4
           (for [{:keys [id custom-name filename]} removed-template-questionnaires]
             [:div.has-text-weight-semibold.has-text-danger {:key id}
              (or custom-name filename)])]])]
      [:h4.title.is-4 "New structured analyses"]
      [:div.is-flex.ml-4 {:style {:width "100%"
                                  :height "100%"
                                  :overflow-y "scroll"}}
       [:f> paginated-list/paginated-list
        {:view-config-path [config/app-db-key]
         :class "p-0"
         :columns column-config
         :hide-header? true
         :hide-pagination? true}
        {:items new-structured-analyses
         :loading @(rf/subscribe [::subs/synchronized-structured-analyses-loading])
         :data-transform (fn [items sort-keyfn sort-comp]
                           (map #(assoc % :paginated-list/row-key (:construct-id %))
                                (tree/sort-hierarchical (map (comp first second) items) sort-keyfn sort-comp :construct-id)))
         :default-sort-keyfn :construct-id
         :default-sort-order :asc}]]]
     [:div.card-footer.p-2
      [:button.button.is-success.card-footer-item
       {:class (when committing?
                 "is-loading")
        :on-click on-commit}
       "Commit changes"]]]))

(rf/reg-event-fx
  ::show-modal
  (fn [_ _]
    {:dispatch [::ui/push-modal {:component #'sync-modal
                                 :ctx {:on-commit #(rf/dispatch [::events/commit-sync])}
                                 :content-props {:style {:width "90vw"
                                                         :height "90vh"
                                                         :padding 0}}}]}))
